module.exports = __webpack_public_path__ + "assets/img/right-layer-1-634b3687.png";